// Slick sliders
$(document).ready(function () {
    slickSlider();
    lazySlider();
});


$(window).on('load', function () {
    lazySlider();
});


// On window.scroll
$(window).on('scroll', function () {
    lazySlider();
});

function lazySlider() {
    $('.slider-lazy.slick-initialized').each(function() {
        let sliderStart = Math.ceil($(this).offset().top);
        let sliderHeight = Math.ceil($(this).outerHeight());
        let sliderEnd = Math.ceil($(this).offset().top + $(this).outerHeight());

        $(this).attr('data-lazy-slider');

        if ((g_scroll + g_windowHeight) > (sliderStart - (g_windowHeight/3))) {
            $(this).find('img').each(function() {
                let imageSrc = $(this).attr('data-src');
                $(this).attr('src', imageSrc);
                $(this).removeAttr('data-src');
            });
            $(this).attr('data-lazy-slider', 'loaded');
            $(this).slick('slickGoTo', 0);
            $(this).removeAttr('data-lazy-slider');
        }
    });
}



function slickSlider() {
    if ($('.slider').length > 0) {
        $('.slider').slick({
            dotsClass: 'slick-dots inside-dots',
            lazyLoad: 'ondemand',
            autoplaySpeed: 5000,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            draggable: true,
            autoplay: false,
            infinite: false,
            arrows: true,
            dots: false,
            speed: 500,
            rows: 0
        });
    }

    if ($('.slider-media').length > 0) {
        $('.slider-media').slick({
            lazyLoad: 'ondemand',
            autoplaySpeed: 5000,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            centerMode: false,
            slidesToShow: 4,
            draggable: true,
            autoplay: false,
            infinite: false,
            arrows: true,
            dots: false,
            speed: 500,
            rows: 0,
            responsive: [{
                breakpoint: 960,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            }]
        });
    }


    $('.slider-single').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.slider-single',
        dots: false,
        centerMode: true,
        focusOnSelect: true
    });
}
